module.exports = __webpack_public_path__ + "img/collection-weddingRingsPolar.7ebd714.webp";